/* Bryny — scroll reveals and small motion helpers. No dependencies. */
(() => {
  const reveal = (els) => {
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
  };

  const init = (scope = document) => {
    reveal(scope.querySelectorAll('[data-b-reveal]:not(.is-in)'));

    // count-up numbers: <span data-b-count="20000" data-b-suffix="+">
    scope.querySelectorAll('[data-b-count]').forEach((el) => {
      if (el.dataset.bDone) return;
      el.dataset.bDone = '1';
      const target = parseFloat(el.dataset.bCount);
      const suffix = el.dataset.bSuffix || '';
      const fmt = (n) => Math.round(n).toLocaleString('en-US') + suffix;
      const run = () => {
        const t0 = performance.now();
        const step = (t) => {
          const p = Math.min(1, (t - t0) / 1600);
          el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => {
          if (es[0].isIntersecting) { run(); io.disconnect(); }
        });
        io.observe(el);
      } else run();
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  // re-run when sections are added or changed in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

// Product page: show the price of the selected bundle (Kaching) on the Add to cart button.
// Kaching already formats the price in the visitor's currency, so we copy its text.
(() => {
  const btn = document.querySelector('.main-product-atc .main-atc__label');
  if (!btn) return;
  const span = document.createElement('span');
  span.className = 'b-atc-price';
  btn.appendChild(span);
  const priceText = () => {
    const sel = document.querySelector('kaching-bundle .kaching-bundles__bar--selected .kaching-bundles__bar-price');
    const fallback = document.querySelector('.product-page-price .price-item--sale, .product-page-price .price-item--regular');
    return ((sel || fallback || {}).textContent || '').trim();
  };
  const update = () => {
    const soldOut = /sold out/i.test((btn.querySelector('.main-atc__label__text') || {}).textContent || '');
    const t = priceText();
    if (span.textContent !== t) span.textContent = t;
    if (span.hidden !== (!t || soldOut)) span.hidden = !t || soldOut;
  };
  update();
  new MutationObserver(update).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('change', () => setTimeout(update, 50));
})();

// Looping proof clips sit inside closed FAQ rows: start them when the row opens.
document.addEventListener('toggle', (e) => {
  const d = e.target; if (!(d instanceof HTMLDetailsElement) || !d.open) return;
  const scope = d.closest('.product__accordion') || d;
  scope.querySelectorAll('video.b-proof__clip').forEach((v) => { v.preload = 'auto'; v.play().catch(() => {}); });
  bLoadImgs(scope);
}, true);

// Proof images inside dropdowns load only when the dropdown is open (data-b-src, see bryny-proof).
function bLoadImgs(scope) {
  scope.querySelectorAll('img[data-b-src]').forEach((img) => { img.src = img.dataset.bSrc; img.removeAttribute('data-b-src'); });
}
document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('details[open]').forEach((d) => bLoadImgs(d.closest('.product__accordion') || d)));

// Speed: the autoplay product video (full quality, 7+ MB) starts after the page has loaded, so the page
// itself isn't slowed down. The poster frame shows until then. Sources are marked data-b-src in product-thumbnail.
(() => {
  const start = () => {
    document.querySelectorAll('video').forEach((v) => {
      const sources = v.querySelectorAll('source[data-b-src]');
      if (!sources.length) return;
      sources.forEach((s) => { s.src = s.dataset.bSrc; s.removeAttribute('data-b-src'); });
      v.muted = true; v.loop = true; v.preload = 'auto';
      v.load();
      v.play().catch(() => {});
    });
  };
  const later = () => setTimeout(start, 200);
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
})();
